module.exports = __webpack_public_path__ + "static/media/34-8.f0c43ea9.mp3";